import { createContext, useState, useContext, useRef } from 'react'

export const FieldFocusContext = createContext()

export const FieldFocusProvider = ({ children }) => {
  const [focusedFieldId, setFocusedFieldId] = useState(null)
  const [elementRef, setElementRef] = useState(null)
  const [helpFields, setHelpFields] = useState({})
  const hoverTimeout = useRef()

  const handleFocus = (id, element) => {
    clearTimeout(hoverTimeout.current)
    hoverTimeout.current = setTimeout(() => {
      setFocusedFieldId(id)
      setElementRef(element)
    }, 50)
  }

  const handleBlur = () => {
    if (!elementRef) return

    const activeEl = document.activeElement
    const stillFocused =
      elementRef === activeEl || elementRef.contains?.(activeEl)

    if (stillFocused) return

    clearTimeout(hoverTimeout.current)
    setFocusedFieldId(null)
    setElementRef(null)
  }
  const registerHelpField = (id, text) => {
    setHelpFields((prev) => ({ ...prev, [id]: text }))
  }

  const resetFieldFocus = () => {
    clearTimeout(hoverTimeout.current)
    setFocusedFieldId(null)
    setElementRef(null)
  }

  return (
    <FieldFocusContext.Provider
      value={{
        focusedFieldId,
        elementRef,
        handleFocus,
        handleBlur,
        registerHelpField,
        helpFields,
        resetFieldFocus,
      }}
    >
      {children}
    </FieldFocusContext.Provider>
  )
}

export const useFieldFocus = () => {
  const ctx = useContext(FieldFocusContext)
  return (
    ctx || {
      handleFocus: () => {},
      handleBlur: () => {},
      registerHelpField: () => {},
      focusedFieldId: null,
      elementRef: null,
      helpFields: {},
      resetFieldFocus: () => {},
    }
  )
}
